<script>
  import ButtonLabel from '#lib/ButtonLabel.svelte';

  /**
   * @typedef {Object} SegmentedOption
   * @property {string} value
   * @property {string} [title]
   * @property {string} [description]
   * @property {string} [icon] name of the icon to be used
   * @property {string} [icon_color1] primary color of icon
   * @property {string} [icon_color2] secondary color of icon
   * @property {boolean} [disabled]
   */

  let {
    /** @type {Array<SegmentedOption>} */
    options = [],
    /** @type {string} selected option - needs to correspond to SegmentedOption.value */
    value = $bindable(),
    on_select,
    direction = 'row',
    class: css_class
  } = $props();

  function select_option(_value) {
    if (on_select) on_select(_value);
    value = _value;
  }

  let selected_option = $derived(options.find((option) => option.value === value));
</script>

<div class='segmented-control button-group auto-scroll-x hide-scrollbar flex-{direction} {css_class}'>
  {#each options as {value, title, description, icon, disabled, icon_color1, icon_color2}}
    <button 
      class='segmented-option'      
      style='--button-icon-color1: {icon_color1}; --button-icon-color2: {icon_color2};'
      onclick={() => !disabled && select_option(value)}
      disabled={disabled}
      title={description}
    >
      <ButtonLabel 
      {...direction === 'row' ? 
        {
          start_icon: icon,
          variant: selected_option?.value === value ? 'canvas segment-selected' : 'canvas segment',
          align: 'center'
        } : {
          end_icon: icon,
          start_icon: selected_option?.value === value ? 'check-inverted' : ' ',
          align: 'between'
        }}
        text_style='text-control'
      >
        {title ?? ''}
      </ButtonLabel>
    </button>
  {/each}
</div>

<style lang='postcss'>
  /* A segmented control is an input: same height token as text inputs and
     dropdowns (compact contexts override --input-min-height upstream, exactly
     like for other inputs). The stroke/radius/clip chrome comes from the
     .button-group styles in ButtonLabel.svelte — adding a border here would
     double it. */
  .segmented-control.flex-row {
    align-items: stretch;
    min-height: var(--input-min-height);
  }

  .segmented-control.flex-row :global(.segmented-option) {
    display: flex;
    align-items: stretch;
  }

  .segmented-control.flex-row :global(.segmented-option > .button-label),
  .segmented-control.flex-row :global(.segmented-option > *) {
    height: 100%;
    display: flex;
    align-items: center;
  }
</style>